// extracted by mini-css-extract-plugin
export default {"userListAssignSec":"UserList_userListAssignSec__S3PTE","userListAssignH6":"UserList_userListAssignH6__+KN9l","userListContentSec":"UserList_userListContentSec__9qkE5"};